// A11 (plan 12/09) — ce que DÉSIGNE un clic sur la légende.
//
// Extrait du gestionnaire `legend.onClick` de ChartBlock parce que c'est la partie qui peut
// se tromper, et la seule qu'on ne peut pas vérifier au navigateur : le canvas de Chart.js
// n'est pas un élément atteignable par l'automatisation (pas de ref, la légende est
// dessinée, pas balisée). Isolée ici, elle se teste sans navigateur ; ce qui reste dans
// ChartBlock — appeler Chart.js puis poser l'état — est du câblage droit.
//
// Le piège est que la légende ne désigne PAS la même chose selon le type de graphique :
//   · anneau            → une CATÉGORIE (Chart.js donne `index`)        → une ligne du tableau
//   · barres, courbes…  → une SÉRIE     (Chart.js donne `datasetIndex`) → une colonne
// Confondre les deux passe inaperçu à la lecture et se voit à l'écran comme « décocher
// Privé efface Collège ».
import { libelleCategorie } from './format'

/** Les libellés décochés, par registre. Deux ensembles, jamais un seul : une catégorie et
 *  une série peuvent porter le même nom sans désigner la même chose. */
export interface Masques {
  series: ReadonlySet<string>
  points: ReadonlySet<string>
}

export const MASQUES_VIDES: Masques = { series: new Set(), points: new Set() }

/** Ajoute ou retire `cle`, en rendant TOUJOURS un nouvel ensemble : muter celui de React
 *  ne déclencherait aucun rendu, et le tableau resterait sur l'état précédent. */
export function basculer(ensemble: ReadonlySet<string>, cle: string): Set<string> {
  const suivant = new Set(ensemble)
  if (suivant.has(cle)) suivant.delete(cle)
  else suivant.add(cle)
  return suivant
}

export interface ItemLegende { index?: number; datasetIndex?: number }

/** Le registre à modifier et le libellé à y basculer — `null` si l'item ne désigne rien
 *  (index absent, hors bornes : Chart.js peut émettre un item incomplet sur un graphe en
 *  cours de reconstruction, et un `undefined` glissé dans l'ensemble masquerait alors une
 *  colonne au hasard). */
export function cibleLegende(
  type: string,
  item: ItemLegende,
  labels: readonly (string | number | null | undefined)[],
  labelSerie: (i: number) => string | undefined,
): { registre: 'series' | 'points'; cle: string } | null {
  if (type === 'doughnut') {
    const i = item.index
    if (i === undefined || i < 0 || i >= labels.length) return null
    return { registre: 'points', cle: libelleCategorie(labels[i]) }
  }
  const i = item.datasetIndex
  if (i === undefined || i < 0) return null
  const cle = labelSerie(i)
  if (cle === undefined) return null
  return { registre: 'series', cle: String(cle) }
}
